/**

 
 */


//获取当天时间
function getTimeOfDay() {
    const myDate = new Date();
    const year = myDate.getFullYear(); // 获取当前年份
    // const month = myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
    // const day = myDate.getDate(); // 获取当前日（1-31）
    const month = ("0" + (myDate.getMonth() + 1)).slice(-2);
    const day = ("0" + myDate.getDate()).slice(-2);
    return `${year}/${month}/${day}`;
}
export default (Vue)=>{
    Vue.directive(
        //防止连续点击
        'preventReclick', {
        inserted(el, binding) {
            el.addEventListener('click', () => {
                if (!el.disabled) {
                    el.disabled = true
                    setTimeout(() => {
                        el.disabled = false
                    }, binding.value || 2000)
                }
            })
        }
    })
}
Date.prototype.format = function(fmt) { 
    var o = { 
       "M+" : this.getMonth()+1,                 //月份 
       "d+" : this.getDate(),                    //日 
       "h+" : this.getHours(),                   //小时 
       "m+" : this.getMinutes(),                 //分 
       "s+" : this.getSeconds(),                 //秒 
       "q+" : Math.floor((this.getMonth()+3)/3), //季度 
       "S"  : this.getMilliseconds()             //毫秒 
   }; 
   if(/(y+)/.test(fmt)) {
           fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length)); 
   }
    for(var k in o) {
       if(new RegExp("("+ k +")").test(fmt)){
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
        }
    }
   return fmt; 
}
export {getTimeOfDay}




// WEBPACK FOOTER //
// ./src/api/utils.js